import { Component } from '@angular/core';

@Component({
  selector: 'app-test-inputs',
  templateUrl: './test-inputs.component.html',
  styleUrls: ['./test-inputs.component.scss']
})
export class TestInputsComponent
{
  public radioValue = 'RATE_BASED';
}
